import { useQuery } from 'services/query'
import { TChannelVariant } from 'interfaces'
import { Spinner } from 'App/components'
import { getCommunityJoinToChannelTokenInfo, handleError } from 'api'

import { useCommunitiesJoinViaLinkCore } from '../useCommunitiesJoinViaLinkCore'

const QUERY_KEY = 'get-community-join-to-channel-token-info'

type TCommunitiesJoinViaLinkToChatProps = {
  variant: Extract<TChannelVariant, 'chat' | 'news'>
}

export const JoinViaLinkToCommunityChannel = ({ variant }: TCommunitiesJoinViaLinkToChatProps) => {
  const { id, token, isNotProfessional, redirectToDefaultPage, redirectToCommunity } =
    useCommunitiesJoinViaLinkCore({ variant })

  const { isFetching } = useQuery({
    queryKey: [QUERY_KEY],
    queryFn: () => getCommunityJoinToChannelTokenInfo({ token, communityId: id }),
    enabled: !isNotProfessional,
    onSuccess: ({ name, isMember, id: channelId }) =>
      redirectToCommunity({
        title: name,
        channelId,
        isMember
      }),
    onError: (err) => {
      handleError(err)
      redirectToDefaultPage()
    }
  })

  if (isFetching) {
    return <Spinner contentCenter />
  }

  return null
}
